import * as maptiler from '@maptiler/sdk';
import '@maptiler/sdk/dist/maptiler-sdk.css';
import { useEffect } from 'react';
import { map } from './Map';
import { empty } from '../helpers/untils';

const ReplayStopAccDotMap = (props) => {
  const { device, positions } = props
  const id = 'replayStopAccDot';

  useEffect(() => {
    map.addSource(id, {
      type: 'geojson',
      data: {
        type: 'FeatureCollection',
        features: [] // initially empty
      }
    });
    map.addLayer({
      source: id,
      id,
      type: "symbol",
      source: id,
      layout: {
        "icon-image": "stop-acc",
        "text-ignore-placement": true,
        "icon-allow-overlap": true,
        "icon-ignore-placement": true,
      },
    });

    map.on('click', id, (e) => {
      const feature = e.features[0];
      console.log('Clicked line feature:', feature.properties);
      const featureProperties = feature.properties
      const position = JSON.parse(featureProperties.position) 
      if (position) {
        window.open(`https://www.google.com/maps/dir/your+location/${position.latitude},${position.longitude}/@${position.latitude},${position.longitude},17z`, '_blank');
      }
    });

    return () => {
      if (map.getLayer(id)) {
        map.removeLayer(id);
      }
      if (map.getSource(id)) {
        map.removeSource(id);
      }
    };
  }, []);

  const createFeatureProperty = (position) => {
    const acc = position.acc ? 1 : 0
    const featureProperty = {
      deviceId: position.deviceId,
      acc: acc,
      speed: position.speed,
      deviceOverSpeed: device.overspeed,
      position: position,
    }
    return featureProperty
  }

  const getFeatureList = (positions) => {
    const featureList = []
    for (let k in positions) {
      if (k > 0) {
        const lastPosition = positions[k - 1]
        const position = positions[k]
        const lastAcc = lastPosition.acc
        const acc = position.acc
        if (lastAcc === 1 && (acc === 0 || empty(acc))) {
          const featureProperty = createFeatureProperty(position)
          const feature = {
            type: 'Feature',
            properties: featureProperty,
            geometry: {
              type: "Point",
              coordinates: [position.longitude, position.latitude]
            }
          }
          featureList.push(feature)
        }
      }
    }
    return featureList
  }

  useEffect(() => {
    const featureList = getFeatureList(positions)
    console.log(`StopAccFeatureList::::`, featureList)
    map.getSource(id).setData(
      {
        type: 'FeatureCollection',
        features: featureList
      }
    );
  }, [positions]);

  return null;
}

export default ReplayStopAccDotMap;
